import { render, staticRenderFns } from "./safeWorkPermitStateDetail.vue?vue&type=template&id=3da57a8e"
import script from "./safeWorkPermitStateDetail.vue?vue&type=script&lang=js"
export * from "./safeWorkPermitStateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3da57a8e')) {
      api.createRecord('3da57a8e', component.options)
    } else {
      api.reload('3da57a8e', component.options)
    }
    module.hot.accept("./safeWorkPermitStateDetail.vue?vue&type=template&id=3da57a8e", function () {
      api.rerender('3da57a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/state/safeWorkPermitStateDetail.vue"
export default component.exports